export const EMAIL_TOKEN_LABELS = {
  customerName: {
    description: 'Customer full name',
    example: 'Jane Smith',
  },
  distributorName: {
    description: 'Distributor or parent company name',
    example: 'Acme Home Services',
  },
  warrantyName: {
    description: 'Contract number with a # prefix',
    example: '#WS-00123',
  },
  policyName: {
    description: 'Policy title',
    example: 'Complete Home Warranty',
  },
  warrantyReferenceId: {
    description: 'Warranty reference ID',
    example: 'ref_abc123',
  },
  warrantyContractNumber: {
    description: 'Contract number (without # prefix)',
    example: 'WS-00123',
  },
  warrantyExpiryDate: {
    description: 'Warranty expiry date after the change described in this email',
    example: 'January 1, 2027',
  },
  portalUrl: {
    description: 'Customer portal link for this warranty',
    example: 'https://portal.example.com/warranty/WS-00123',
  },
  portalButton: {
    description: 'Structured portal CTA button placeholder',
    example: '{{portalButton}}',
  },
  claimButton: {
    description: 'Structured claim CTA button placeholder',
    example: '{{claimButton}}',
  },
  redirectButton: {
    description: 'Structured login/redirect CTA button placeholder',
    example: '{{redirectButton}}',
  },
  productTeam: {
    description: 'Configured email sign-off team name',
    example: 'Marine Protection Team',
  },
  currentYear: {
    description: 'Current year at send time',
    example: '2026',
  },
  supportEmail: {
    description: 'Configured contact/support email address',
    example: 'connex-support@warrantysphere.com',
  },
  loginUrl: {
    description: 'Magic login link URL',
    example: 'https://portal.example.com/auth/login?token=abc123',
  },
  userName: {
    description: "Recipient's display name",
    example: 'Jane Smith',
  },
  brandName: {
    description: 'Tenant brand name',
    example: 'Acme',
  },
  productName: {
    description: 'Tenant product name',
    example: 'Home Warranty',
  },
  claimId: {
    description: 'Claim ID (internal)',
    example: 'clm_7f3c2a6b9d1e4f0aa1b2c3d4e5f67890',
  },
  claimNumber: {
    description: 'Claim number shown to the customer',
    example: 'CLM-00123',
  },
  customerFirstName: {
    description: 'Customer first name',
    example: 'Jane',
  },
  claimUrl: {
    description: 'Customer portal link for this claim',
    example: 'https://portal.example.com/warranty/WS-00123/claim/clm_7f3c2a6b9d1e4f0aa1b2c3d4e5f67890',
  },
  instructionImage: {
    description: 'Optional instructional image, rendered inline where this token is placed',
    example: '{{instructionImage}}',
  },
} as const;
